
import auth from './AuthAPI.js'
import * as APPCONFIG from '../config/app-config.js'
import Http from './Http.js';

class BuildingsApi {
  
    saveBuilding(form) {
        return auth({
          method: "post",
          headers: Http.MULTIPART_HEADERS(),
          url: `${APPCONFIG.API_URL}api/saveBuildingV2`,
          data: form,
        });
      }   

   
      getBuildingList(form) {
        return auth({
            method: "post",
            headers: Http.AUTH_HEADERS(),
            url: `${APPCONFIG.API_URL}api/getBuildingList`,
            data: JSON.stringify(form),
          });
      }

      
       
      editBuilding(form) {
        return auth({
            method: "post",
            headers: Http.MULTIPART_HEADERS(),
            url: `${APPCONFIG.API_URL}api/editBuildingV2`,
            data: form,
          });
      }

      deletebuilding(form) {
        return auth({
            method: "post",
            headers: Http.AUTH_HEADERS(),
            url: `${APPCONFIG.API_URL}api/deletebuilding`,
            data: JSON.stringify(form),
          });
      }



      // -----"drop down"----------------


      
      getBuildingData(form) {
        return auth({
            method: "post",
            headers: Http.AUTH_HEADERS(),
            url: `${APPCONFIG.API_URL}api/getBuildingData`,
            data: JSON.stringify(form),
          });
      }


      
      getVehicleData(form) {
        return auth({
            method: "post",
            headers: Http.AUTH_HEADERS(),
            url: `${APPCONFIG.API_URL}api/getVehicleData`,
            data: JSON.stringify(form),
          });
      }

      getEquipmentData(form) {
        return auth({
            method: "post",
            headers: Http.AUTH_HEADERS(),
            url: `${APPCONFIG.API_URL}api/getEquipmentData`,
            data: JSON.stringify(form),
          });
      }

   





      
}

export default new BuildingsApi();